import React from 'react';

const Footer = () => {
    const currentDate = new Date();
const currentYear = currentDate.getFullYear();
  return (
    <div className="mb-12 print:hidden">
      <p className='text-sm text-center'>© HCS {currentYear}. All Rights Reserved</p>
      <p className='text-sm text-center'>Powered by HCS</p>
    </div>
  );
};

export default Footer;
